module.exports = __webpack_public_path__ + "img/card_img_9.d78cd75f.png";